export default "__VITE_ASSET__BhhAmaJf__"